import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router';
import { compose, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import AddressFooter from '../../shared/AddressFooter';

const MembershipMigration = ({ customerName, brandName, brandLogo, backgroundImage, onUpdate }) => (
  <div>
    <div className="c-membership-wrapper">
      <div className="c-membership-header">
        <img src={brandLogo} className="c-brand-logo u-mb-8" alt={brandName} />
        <h2 className="c-membership-title">Your barbershop is coming to Squire</h2>
        {backgroundImage && <img src={backgroundImage} className="c-brand-background u-mb-8" alt={brandName} />}
      </div>
      <div className="c-membership-text u-mb-8">
        <p>Hey {customerName}!</p>

        <p>Great news, your barbershop has moved to Squire! The most successful barbershops run on <a href="https://getsquire.com">Squire</a>, confirming your membership details will ensure that your next appointment is as smooth as your last.</p>

        <p>To continue your membership with {brandName} please update your payment details. If
        you choose not to update your payment details now, you can do so during your next appointment.</p>

        <p>Cheers, <br />
          {brandName}
        </p>
      </div>
      <button className="c-btn c-btn--primary c-membership-btn" onClick={onUpdate}>
      Update Credit Card Details
    </button>
    </div>
    <AddressFooter />
  </div>
);

MembershipMigration.propTypes = {
  customerName: PropTypes.string.isRequired,
  brandName: PropTypes.string.isRequired,
  brandLogo: PropTypes.string.isRequired,
  backgroundImage: PropTypes.string.isRequired,
  onUpdate: PropTypes.func.isRequired,
};

export default compose(
  withRouter,
  connect(
    (state, ownProps) => ({
      customerName: ownProps.location.query.customerName,
      brandName: ownProps.location.query.brandName,
      brandLogo: ownProps.location.query.brandLogo,
      backgroundImage: ownProps.location.query.backgroundImage,
      updateLink: ownProps.location.query.updateLink,
    })
  ),
  withHandlers({
    onUpdate: props => () => {
      props.router.replace(props.updateLink);
    },
  }),
)(MembershipMigration);



// WEBPACK FOOTER //
// ./src/app/notifications/membership/MembershipMigration/index.jsx